import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FormularioEdicao = _resolveComponent("FormularioEdicao")!

  return (_openBlock(), _createBlock(_component_FormularioEdicao, {
    editor: (_ctx.editor as FormularioEditor),
    onCriou: _ctx.criar,
    onAtualizou: _ctx.alterar
  }, null, 8, ["editor", "onCriou", "onAtualizou"]))
}